import type { StyleLayer } from './utils/types'

export const layers_bikelanes_widths: StyleLayer[] = [
  {
    id: 'widths-lines-incomplete',
    type: 'line',
    filter: ['!', ['has', 'width']],
    paint: {
      'line-color': '#fda5e4',
      'line-dasharray': [3, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 12, 1, 22, 4],
    },
  },
  {
    id: 'widths-lines',
    type: 'line',
    filter: ['has', 'width'],
    paint: {
      'line-color': [
        'interpolate',
        ['linear'],
        ['get', 'width'],
        0.5,
        '#ef9043',
        1.1,
        '#f6de09',
        1.6,
        '#a1e217',
        2.2,
        '#15c65c',
      ],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 3, 16, 4],
    },
  },
]
